import { BookingV4 } from "../../types/bookings";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

export const fetchBookingV4FromAPI = async (
  id: string
): Promise<BookingV4 | undefined> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  return await fetch(`${environmentVars?.CORE_API_BASE_URL}/bookings/${id}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(async (response) => {
      if (response.ok) {
        return (await response.json()).payload?.booking;
      }

      apiFetchNotOkHandler(response, "Error fetching booking");
      return undefined;
    })
    .catch((error) => {
      errorHandler(error, "Error fetching booking");

      return undefined;
    });
};
